import React, { useCallback, useEffect } from 'react';
import { BrowserRouter, useLocation, useNavigate } from 'react-router-dom';

import { CookieConsentBanner } from './components/CookieConsentBanner';
import { ErrorBoundary } from './components/common';
import { NetworkStatus } from './components/common/NetworkStatus';
import { OAuthTokenExpiredModal } from './components/OAuthTokenExpiredModal';
import { AppProvider } from './contexts/AppContext';
import { SocketProvider } from './contexts/SocketContext';
import { AppRoutes } from './routes/AppRoutes';

const EmailVerificationHandler: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleEmailVerificationRequired = useCallback(() => {
    if (!location.pathname.startsWith('/verify-email')) {
      navigate('/verify-email', { replace: true });
    }
  }, [navigate, location.pathname]);

  useEffect(() => {
    window.addEventListener('auth:email-verification-required', handleEmailVerificationRequired);
    return () => {
      window.removeEventListener(
        'auth:email-verification-required',
        handleEmailVerificationRequired,
      );
    };
  }, [handleEmailVerificationRequired]);

  return <>{children}</>;
};

function App() {
  return (
    <ErrorBoundary>
      <AppProvider>
        <SocketProvider>
          <BrowserRouter>
            <EmailVerificationHandler>
              <OAuthTokenExpiredModal />
              <NetworkStatus />
              <CookieConsentBanner />
              <AppRoutes />
            </EmailVerificationHandler>
          </BrowserRouter>
        </SocketProvider>
      </AppProvider>
    </ErrorBoundary>
  );
}

export default App;
